import Config from '../Config'

const BASE_URL = `${Config.API}/contact`

const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
})

export interface ContactRequest {
  title: string
  message: string
}

export const sendContactRequest = async (
  contactRequest: ContactRequest,
): Promise<void> => {
  await fetch(`${BASE_URL}/`, {
    method: 'POST',
    headers: { ...getHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(contactRequest),
  })
}
